import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<section class=\"content-header\"><div class=\"container-fluid\"><div class=\"row mb-2\"><div class=\"col-sm-6\"><h1>Tipos de produtos</h1></div><div class=\"col-sm-6\"><ol class=\"breadcrumb float-sm-right\"><li class=\"breadcrumb-item\"><a href=\"#\">Home</a></li><li class=\"breadcrumb-item active\">Tipos de produtos</li></ol></div></div></div></section>", 1)
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "container-fluid" }
const _hoisted_4 = { class: "card" }
const _hoisted_5 = { class: "card-header" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, "Novo", -1)
const _hoisted_7 = { class: "card-tools" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-left" }, null, -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "card-body row" }
const _hoisted_11 = { class: "form-group col-12 col-md-6" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { for: "description" }, [
  /*#__PURE__*/_createTextVNode("Descrição "),
  /*#__PURE__*/_createElementVNode("sup", { class: "text-danger" }, "* ")
], -1)
const _hoisted_13 = { class: "form-group col-12 col-md-6" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { for: "enabled" }, "Situação", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = { class: "card-footer text-center" }
const _hoisted_17 = { class: "btn-group" }

export function render(_ctx, _cache) {
  const _component_Toggle = _resolveComponent("Toggle")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-tool",
                onClick: _cache[0] || (_cache[0] = $event => (_ctx.goBack())),
                title: "Voltar"
              }, _hoisted_9)
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _withDirectives(_createElementVNode("div", { class: "col-12 alert alert-danger" }, _toDisplayString(_ctx.errorMessage), 513), [
              [_vShow, _ctx.errorMessage != '']
            ]),
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _withDirectives(_createElementVNode("input", {
                id: "description",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.row.description) = $event)),
                type: "text",
                class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.description }]),
                maxlength: "50"
              }, null, 2), [
                [_vModelText, _ctx.row.description]
              ]),
              _withDirectives(_createElementVNode("span", { class: "help-inline" }, _toDisplayString(_ctx.errors.description), 513), [
                [_vShow, _ctx.errors.description != null]
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _hoisted_15,
              _createVNode(_component_Toggle, {
                modelValue: _ctx.row.enabled,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.row.enabled) = $event)),
                "on-label": "Ativo",
                "off-label": "Inativo",
                class: "toggle-enabled"
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("button", {
                type: "button",
                id: "cancelButton",
                class: "btn btn-warning",
                onClick: _cache[3] || (_cache[3] = $event => (_ctx.goBack()))
              }, "Cancelar"),
              _createElementVNode("button", {
                type: "button",
                id: "gravarButton",
                class: "btn btn-success",
                onClick: _cache[4] || (_cache[4] = $event => (_ctx.save()))
              }, "Gravar")
            ])
          ])
        ])
      ])
    ])
  ], 64))
}